import { render, staticRenderFns } from "./AssignManager.vue?vue&type=template&id=3b9a7672"
import script from "./AssignManager.vue?vue&type=script&lang=js"
export * from "./AssignManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports